jQuery(document).ready(function ($) {

  var search = document.querySelector('#front-page #search-form');

  if(search){
    var searchOffsetTop = search.offsetTop;
    search.dataset.scrollTop = searchOffsetTop;
  }

  console.log(document.querySelector('#front-page #search-form'));

  if ($('#front-page').length === 0 && $('#materialpool').length === 0) {
    $('#search-menu').show( document.querySelector('#front-page #search-form'));
  }

  //window scrolling

  $(window).scroll(function () {
    var currentScroll = $(window).scrollTop();
    $('#search-form').bind('focus', function (e) {
      e.preventDefault();
    });

    if (currentScroll > 30) {
      //$('#site-header').addClass('-small');
      //$('#site-main').addClass('-small');
      $('#materialpool').find('#search-form').addClass('-sticky');

      if ($('#materialpool').length > 0 && $(window).width() < 650) {
        $('#search-menu').fadeIn();
      }

      if(!search){
        return;
      }

      if (currentScroll >   search.dataset.scrollTop) {
        $('#front-page').find('#search-form').addClass('-sticky');
        if ($(window).width() < 650) {
          $('#search-menu').fadeIn();
          if (!$('#search-menu').data(search)) {
            $('#front-page').find('#search-form').hide();
          }
        }
      } else {
        $('#front-page').find('#search-form').removeClass('-sticky').show();
        $('#slider-container').css('min-height', 'auto');
        $('.home').find('#search-menu').fadeOut();
      }
    } else {
     // $('#site-header').removeClass('-small');
      //$('#site-main').removeClass('-small');
    
      $('#materialpool').find('#search-form').removeClass('-sticky');

      if ($('#materialpool').length > 0 && $(window).width() < 650) {
        $('#search-menu').fadeOut();
      }
    }
  });

  //open search form on mobile

  $('#search-menu').click(function (e) {
    if ($(e.target).data('search')) {
      $('#search-menu').data('search', false);
      $('#search-form').fadeOut('slow', function () {
        $(this).css({ top: '0px' });
      });
    } else {
      $('#search-menu').data('search', true);
      $('#search-form').css('top', '123px').fadeIn('slow');
    }
  });

  //open dropdown Menu mobile
  $('.menu-toggle').click(function (e) {
    $('#header-menu').find('>ul, >div').slideToggle();
    if ($(e.target).find('>.fa').hasClass('fa-times')) {
      $(e.target).find('>.fa').removeClass('fa-times');
      $(e.target).find('>.fa').addClass('fa-bars');
      return;
    }
    $(e.target).find('>.fa').removeClass('fa-bars');
    $(e.target).find('>.fa').addClass('fa-times');
  });

  $('#header-menu').find('[data-toggle]').click(function (e) {
    $(e.target).parent().find('>ul, >div').slideToggle();
    if ($(e.target).hasClass('fa-bars')) {
      $(e.target).removeClass('fa-bars');
      $(e.target).addClass('fa-times');
      return;
    }

    if ($(e.target).hasClass('fa-times')) {
      $(e.target).removeClass('fa-times');
      $(e.target).addClass('fa-bars');
      return;
    }

    if ($(e.target).hasClass('fa-angle-down')) {
      $(e.target).parent().addClass('-open');
      $(e.target).removeClass('fa-angle-down');
      $(e.target).addClass('fa-angle-up');
      return;
    }
    $(e.target).removeClass('fa-angle-up');
    $(e.target).addClass('fa-angle-down');
    $(e.target).parent().removeClass('-open');
  });

  //dropdown menu
  $('body').click(function (e) {
    var clickedOn = $(e.target).parent();

    if ($(clickedOn).is('#menu-item-login') && $(window).width() > 1040) {
      if ($(clickedOn).hasClass('-open')) {
        $(clickedOn).removeClass('-open');
        $(clickedOn).find('>.wrapper').css('display', 'none');
        return;
      }

      $(clickedOn).addClass('-open');
      $(clickedOn).find('>.wrapper').css('display', 'block');
    }
  });

  $('#close').click(function (e) {
    $('#menu-item-login').removeClass('-open');
    $('#menu-item-login').find('>.wrapper').css('display', 'none');
    return;
  });


  // //make the button sizes even on material page
  var height = parseInt($('.info-buttons').find('.button.-dark').css('height'), 10);
  var paddingExtra = (height - parseInt($('.info-buttons').find('.button.-light').css('height'), 10)) / 2;
  var paddingOriginal = parseInt($('.info-buttons').find('.button.-light').css('padding-top'), 10);
  $('.info-buttons').find('.button.-light').css('padding-top', paddingExtra + paddingOriginal);
  $('.info-buttons').find('.button.-light').css('padding-bottom', paddingExtra + paddingOriginal);

});



